import { UserDropdownItem, getUserDropdown } from "@dgs/core";
import { useProfile } from "./profileService";

interface Props {
	items: UserDropdownItem[];
}

const BaseUserDropdown = getUserDropdown();

export function ProfileDropdown({ items }: Props) {
	const { profile } = useProfile();

	if (!profile) {
		return null;
	}

	const firstName = profile.attributes.find((h) => h?.type === "FIRST_NAME")?.value ?? "";
	const lastName = profile.attributes.find((h) => h?.type === "LAST_NAME")?.value ?? "";
	const company = profile.attributes.find((h) => h?.type === "PRIMARY_COMPANY")?.value?.company ?? "";

	return <BaseUserDropdown name={`${firstName} ${lastName}`} company={company} image={profile.image} items={items} />;
}
